import { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { API } from "../../App";
import { Switch } from "../../components/ui/switch";
import { Globe } from "lucide-react";

export default function AdminLanguages() {
  const [rows, setRows] = useState([]);
  const load = () => axios.get(`${API}/admin/languages`).then((r) => setRows(r.data.items || []));
  useEffect(() => { load(); }, []);

  const toggle = async (code, active) => {
    try {
      await axios.patch(`${API}/admin/languages/${code}`, { active });
      load();
      toast.success(`${code.toUpperCase()} ${active ? "activated" : "deactivated"}`);
    } catch { toast.error("Update failed"); }
  };

  return (
    <div data-testid="admin-languages">
      <div className="text-[10px] kt-tracking-wider uppercase text-[#6F6B66] mb-2 flex items-center gap-2"><Globe className="h-3.5 w-3.5" /> Languages</div>
      <h1 className="font-serif text-3xl text-[#383633] tracking-tight mb-2">Language visibility</h1>
      <p className="text-sm text-[#6F6B66] mb-8 max-w-lg">English and Italian are the primary interface languages. Additional languages appear inside the globe menu when active. Arabic and Persian are shown with full RTL support.</p>
      <div className="bg-white border kt-line rounded-2xl overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-[#F8F6F2] text-[#6F6B66]">
            <tr>
              <th className="text-left px-4 py-3 kt-tracking uppercase text-[10px]">Code</th>
              <th className="text-left px-4 py-3 kt-tracking uppercase text-[10px]">Name</th>
              <th className="text-left px-4 py-3 kt-tracking uppercase text-[10px]">Native</th>
              <th className="text-left px-4 py-3 kt-tracking uppercase text-[10px]">Direction</th>
              <th className="text-left px-4 py-3 kt-tracking uppercase text-[10px]">Active</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((r) => (
              <tr key={r.code} className="border-t kt-line" data-testid={`lang-row-${r.code}`}>
                <td className="px-4 py-3 font-mono uppercase text-[#383633]">{r.code}</td>
                <td className="px-4 py-3 text-[#383633]">{r.name}</td>
                <td className="px-4 py-3 text-[#6F6B66]">{r.native}</td>
                <td className="px-4 py-3 text-xs kt-tracking uppercase text-[#6F6B66]">{r.rtl ? "RTL" : "LTR"}</td>
                <td className="px-4 py-3">
                  <Switch
                    checked={!!r.active}
                    onCheckedChange={(v) => toggle(r.code, v)}
                    data-testid={`lang-toggle-${r.code}`}
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
